import { SliderAd as SliderAdModel } from 'models/SliderAd';
import CarouselAd, { CarouselAdProps } from 'components/Shared/Carousel/carouselAd';
import Carousel from 'components/Shared/Carousel';
import cn from 'classnames';
import { TakeoverAd } from 'components/Shared/TakeoverAd';
import { TakeoverAd as TakeoverAdModel } from 'models/TakeoverAd';
import { Section } from 'components/Shared/Layout';
import styles from './styles.scss';
import { AppearanceTypes } from 'components/Shared/Layout/base';
import connect from 'components/Shared/connect';
import { BasePageModel } from 'models/BasePageModel';
import { NO_ELEMENT } from 'utils';

interface OwnProps {
  sliderAds: SliderAdModel[];
  gotoOfferText: string;
  takeoverAd?: TakeoverAdModel;
  adAppearance?: AppearanceTypes;
}
type MergedProps = Pick<BasePageModel, 'webCatalog'> & OwnProps;

const RenderTab = ({
  goToSlide,
  active,
  slide
}: {
  goToSlide: () => void;
  active: boolean;
  slide: { title: string };
}) => (
  <div onClick={goToSlide} className={cn(styles.sliderTab, { [styles.sliderTabActive]: active })}>
    {slide.title}
  </div>
);
// const RenderTab = (props: CarouselAdProps, goToSlide: () => void, active: boolean) => ();

const hasAds = (sliderAds: SliderAdModel[]) => sliderAds && sliderAds.length > 0;

const panorama = ({
  takeoverAd,
  gotoOfferText,
  sliderAds,
  adAppearance = 'primary',
  webCatalog
}: MergedProps) =>
  hasAds(sliderAds) ? (
    <Section appearance="secondary" shadow className={styles.panorama}>
      {takeoverAd && <TakeoverAd ad={takeoverAd} />}
      <Carousel
        key={webCatalog}
        displayControls
        autoplay
        RenderSlideTab={RenderTab}
        slidesData={sliderAds}
        onStartPage
      >
        {(slide: CarouselAdProps, i) => (
          <CarouselAd
            {...slide}
            key={slide.ticket}
            gotoOfferText={gotoOfferText}
            appearance={adAppearance}
            position={i + 1}
          />
        )}
      </Carousel>
    </Section>
  ) : (
    NO_ELEMENT
  );

export const Panorama = connect<MergedProps, OwnProps>(state => ({
  webCatalog: state.currentPage.webCatalog
}))(panorama);
